import DynamicModule from './DynamicModule'

export default DynamicModule
